import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { User } from 'src/app/models/user';

@Component({
  selector: 'ark-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  isAdmin:boolean = (localStorage.getItem('isAdmin') == 'true'? true : false );
  dialogConfig: any;
  isRole:boolean = false; 
  isOpen:boolean = false;
  activeform:boolean = false;
  activeApprover:boolean = false;
  activeReport:boolean = false;
  isClass:any;
  parent_active = '';
  user = new User();


  constructor(
    private _router: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
  ) {
    this.isRole = this.user.getRole();
  }

  ngOnInit() {
    this._router.queryParams.subscribe( params =>{
      if (Object.keys(params).length) {
        this.removeClass();
        this.activeApprover = true;
      }
    });
  }

  getReport() {
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';
    let dialogRef = this.dialog.open(null, this.dialogConfig);
  }

  hasClass(e){
    if (e == 1) {
      this.activeform = true;
      this.activeApprover = false;
      this.activeReport = false;
    } else if (e == 2) {
      this.activeApprover = true;
      this.activeform = false;
      this.activeReport = false;
    } else if (e == 3) {
      this.activeReport = true;
      this.activeApprover = false;
      this.activeform = false;
    }
  }

  removeClass(){
    this.activeform = false;
    this.activeApprover = false;
    this.activeReport = false;
  }

}
